/**
 * Source of truth for the 10 CITY RUN families.
 * Order = left-to-right rendering order.
 */
export const MAX_POSITION = 24;

export const FAMILIES = [
  { slug: "azure-crown",       name: "The Oracles",     color: "#3B82F6", emblem: "/emblems/Azure_Crown.png" },
  { slug: "prism-order",       name: "The Axioms",      color: "#E879F9", emblem: "/emblems/Prism_Order.png" },
  { slug: "violet-veil",       name: "The Celestials",  color: "#A855F7", emblem: "/emblems/Violet_Veil.png" },
  { slug: "crimson-syndicate", name: "The Sovereigns",  color: "#EF4444", emblem: "/emblems/Crimson_Syndicate.png" },
  { slug: "verdant-vault",     name: "The Obsidian",    color: "#10B981", emblem: "/emblems/Verdant_Vault.png" },
  { slug: "crystal-dominion",  name: "The Ascendants",  color: "#E5E7EB", emblem: "/emblems/Crystal_Dominion.png" },
  { slug: "solar-dynasty",     name: "The Harbingers",  color: "#F59E0B", emblem: "/emblems/Solar_Dynasty.png" },
  { slug: "obsidian-core",     name: "The Helix",       color: "#9CA3AF", emblem: "/emblems/Obsidian_Core.png" },
  { slug: "amber-forge",       name: "The Parallax",    color: "#F97316", emblem: "/emblems/Amber_Forge.png" },
  { slug: "fracture-protocol", name: "The Singularity", color: "#22D3EE", emblem: "/emblems/Fracture_Protocol.png" },
];

/**
 * Generate the 24-position lane pattern:
 * 5 dashes, 1 square, 5 dashes, 1 square, 5 dashes, 1 square, 5 dashes, 1 square.
 * Position 1 = index 0 (bottom-most, closest to START).
 * Position 24 = index 23 (topmost, at the finish line).
 * Checkpoints land on positions 6, 12, 18, 24.
 */
export function buildLanePositions() {
  const positions = [];
  for (let i = 1; i <= MAX_POSITION; i += 1) {
    positions.push({
      index: i,
      kind: i % 6 === 0 ? "checkpoint" : "dash",
    });
  }
  return positions;
}

export const LANE_POSITIONS = buildLanePositions();
